export type {
  HeadingAlign,
  HeadingColor,
  HeadingEmphasis,
  HeadingLevel,
  HeadingProps,
  HeadingSize,
  HeadingWeight,
} from '../../types/heading';
export type {
  TextAlign,
  TextColor,
  TextEmphasis,
  TextProps,
  TextVariant,
  TextWeight,
} from '../../types/text';
export { Heading } from './adapters/inbound/Heading';
export { Text } from './adapters/inbound/Text';
